<template>
  <ol v-if="content.children.length">
    <li v-for="(obj, index) of content.children">
      <div class="sub-title">{{ index + 1 }}. {{ obj.header[0].content }}</div>
      <Depth3Main
        :parentIndexes="[index]"
        :content="obj"
      />
    </li>
  </ol>
</template>
<script>
import Depth3Main from './Depth3Main.vue'

export default {
  props: {
    content: Object,
    parentIndexes: Array,
  },
  components: {
    Depth3Main,
  },
}
</script>
<style lang="scss" scoped>
@import '../TermsOfUse.scss';
</style>
